import type { WatchdogsFeatureConfig } from './type';

export const watchdogs: Partial<WatchdogsFeatureConfig> = {
    showOverviewDescription: 'physical-person-segment-only',
    channelSelectionDisclaimer: 'type-specific',
};
